import type { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { focusVisibleMixin } from '@elfsight/widget-ui';

export function Description({ children }: PropsWithChildren) {
  return (
    <DescriptionComponent
      dangerouslySetInnerHTML={{
        __html: children as string
      }}
    />
  );
}

export const DescriptionComponent = styled.div`
  opacity: 0.65;
  font-size: ${({
    theme: {
      itemDescriptionFontSize: { fontSize }
    }
  }) => fontSize}px;
  line-height: 1.38;
  text-align: left;
  color: rgba(17, 17, 17, 0.65);
  margin-top: 2px;
  word-break: break-word;

  & a {
    ${focusVisibleMixin()}
  }
`;
